export const redColor = '#ef0606';
export const greenColor = '#73C766';
export const darkGreenColor = '#2e7d32';
export const orangeColor = '#ff8566';
export const grayColor = '#b7b7b7';
